import { useEffect } from "react";
import getOwnerDocument from "../../utils/getOwnerDocument";
export var useOnOutsideClick = function(refs, onCloseEvent, menuOpen) {
    useEffect(function() {
        var listener = function(event) {
            if (!menuOpen) {
                return;
            }
            if (Array.isArray(refs)) {
                if (refs.some(function(ref) {
                    return menuOpen && (!ref.current || ref.current.contains(event.target));
                })) {
                    return;
                }
            } else if (menuOpen && (!refs.current || refs.current.contains(event.target))) {
                return;
            }
            onCloseEvent(event);
        };
        var ownerDocument = getOwnerDocument(Array.isArray(refs) ? refs[0].current : refs.current);
        if (ownerDocument) {
            ownerDocument.addEventListener('mousedown', listener);
            ownerDocument.addEventListener('touchstart', listener);
        }
        return function() {
            if (ownerDocument) {
                ownerDocument.removeEventListener('mousedown', listener);
                ownerDocument.removeEventListener('touchstart', listener);
            }
        };
    });
};
export default useOnOutsideClick;
